export enum TransactionType {
  INCOME = 'income',
  SPENDING = 'spending',
}
